"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrescribeView = void 0;
require("./prescribe-view.less");
const React = require("react");
const moment = require("moment");
const order_1 = require("shared/order");
const claim_1 = require("shared/claim");
const material_ui_1 = require("material-ui");
const filter_bar_1 = require("client/components/filter-bar");
const floating_page_1 = require("client/components/page/floating-page");
const kpi_header_1 = require("client/components/kpi-header");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const switch_1 = require("client/components/material/switch");
const modal_1 = require("client/components/modal");
const prescribe_kpi_1 = require("client/modules/prescribe/modules/prescribe-view/components/prescribe-kpi");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/users/store");
let PrescribeView = class PrescribeView extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.complete = 0;
        this.incomplete = 0;
        this.showComplete = false;
        this.showModal = false;
        this.sortBy = "localeDate";
        this.sortDirection = "DESC";
        this.filterText = "";
        this.calculateComplete = () => {
            var _a;
            const complete = (_a = this.ordersAll) === null || _a === void 0 ? void 0 : _a.filter((order) => {
                const done = order.status === order_1.OrderStatus.Done;
                const submitted = order.auditStatus !== order_1.AuditStatus.Unsubmitted;
                if (done || submitted) {
                    return order;
                }
                return false;
            });
            this.complete = complete.length;
            this.incomplete = this.ordersAll.length - this.complete;
        };
        this.loadOrders = async () => {
            var _a, _b;
            const result = await store_1.ordersStore.loadPrescribe();
            this.ordersAll = (_a = result.orders) !== null && _a !== void 0 ? _a : [];
            this.provider = (_b = result.provider) !== null && _b !== void 0 ? _b : null;
            this.ordersFiltered = this.ordersAll;
            this.calculateComplete();
        };
        this.handleClickDone = async (e, orderId) => {
            e.stopPropagation();
            await store_1.ordersStore.updateAuditStatus(orderId);
            await this.loadOrders();
        };
        this.handleClickModal = (drug) => {
            this.showModal = !this.showModal;
            this.modalDrug = drug;
        };
        this.handleClickPrescribe = async (claimId) => {
            await store_1.ordersStore.updatePrescribe(claimId);
            await this.loadOrders();
        };
        this.handleClickRow = (index) => {
            this.currentRowIndex = this.currentRowIndex === index ? null : index;
        };
        this.handleClickShowComplete = () => {
            this.showComplete = !this.showComplete;
            this.forceUpdate();
        };
        this.handleFilterSearch = (query) => {
            this.filterText = query;
            this.ordersFiltered = this.ordersAll.filter((order) => {
                const patient = order.patient;
                const patientFirstNoCase = patient.firstName.toLowerCase();
                const patientLastNoCase = patient.lastName.toLowerCase();
                const queryNoCase = query.toLowerCase();
                if (patientFirstNoCase.includes(queryNoCase) ||
                    patientLastNoCase.includes(queryNoCase)) {
                    return order;
                }
                return false;
            });
            this.forceUpdate();
        };
        this.renderFilter = () => (React.createElement("div", { className: "inventory__filter" },
            React.createElement(filter_bar_1.FilterBar, { callBack: this.handleFilterSearch, filterText: this.filterText })));
        this.renderInfoModal = () => {
            const drug = this.modalDrug;
            return (React.createElement(modal_1.Modal, { onCancel: () => this.handleClickModal(null) },
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement("b", null, "NDC"),
                        ": ",
                        drug.package),
                    React.createElement("li", null,
                        React.createElement("b", null, "Name"),
                        ": ",
                        drug.strengthDescription),
                    React.createElement("li", null,
                        React.createElement("b", null, "Alt Name"),
                        ": ",
                        drug.name),
                    React.createElement("li", null,
                        React.createElement("b", null, "Generic"),
                        ": ",
                        drug.generic),
                    React.createElement("li", null,
                        React.createElement("b", null, "Type"),
                        ": ",
                        drug.type),
                    React.createElement("li", null,
                        React.createElement("b", null, "Description"),
                        ": ",
                        drug.description),
                    React.createElement("li", null,
                        React.createElement("b", null, "Supply"),
                        ": ",
                        drug.daysSupply),
                    React.createElement("li", null,
                        React.createElement("b", null, "Refills"),
                        ": ",
                        drug.refills),
                    React.createElement("li", null,
                        React.createElement("b", null, "Quantity"),
                        ": ",
                        drug.claimQuantity),
                    React.createElement("li", null,
                        React.createElement("b", null, "Unit"),
                        ": ",
                        drug.unit)),
                React.createElement(button_1.MaterialButton, { onClick: () => this.handleClickModal(null), secondary: true, style: { alignSelf: "center", width: "fit-content" } }, "Close")));
        };
        this.renderList = () => {
            var _a;
            const columns = [
                {
                    id: "firstName",
                    label: "First Name"
                },
                {
                    id: "lastName",
                    label: "Last Name"
                },
                {
                    id: "localeDate",
                    label: "Appointment time"
                },
                {
                    id: "approvals",
                    label: "Approvals"
                },
                {
                    id: "button",
                    label: ""
                }
            ];
            return (React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.handleSort, order: this.sortDirection, orderBy: this.sortBy, rows: (_a = this.ordersFiltered) !== null && _a !== void 0 ? _a : [], renderRow: this.renderListRow }));
        };
        this.handleSort = (sortBy) => {
            if (sortBy === "approvals")
                return;
            if (this.sortBy === sortBy) {
                this.sortDirection = this.sortDirection === "ASC" ? "DESC" : "ASC";
            }
            else {
                this.sortBy = sortBy;
                this.sortDirection = "ASC";
            }
            this.currentRowIndex = null;
            this.ordersFiltered = this.ordersFiltered.sort((a, b) => {
                const byPatient = sortBy === "lastName" || sortBy === "firstName";
                const propA = byPatient
                    ? a.patient[sortBy].toUpperCase()
                    : a[sortBy];
                const propB = byPatient
                    ? b.patient[sortBy].toUpperCase()
                    : b[sortBy];
                if (propA < propB)
                    return this.sortDirection === "DESC" ? 1 : -1;
                if (propA > propB)
                    return this.sortDirection === "DESC" ? -1 : 1;
                return 0;
            });
        };
        this.renderListRow = (order, index) => {
            var _a, _b, _c, _d, _e;
            const { patient } = order;
            const completeStatuses = [claim_1.ClaimStatus.Intended, claim_1.ClaimStatus.Dispensed];
            const approvals = (_b = (_a = order.claims) === null || _a === void 0 ? void 0 : _a.filter((claim) => claim.status === claim_1.ClaimStatus.Paid).length) !== null && _b !== void 0 ? _b : 0;
            const completed = (_c = order.claims) === null || _c === void 0 ? void 0 : _c.some((claim) => completeStatuses.includes(claim.status));
            const apptTime = moment(order.localeDate).format("h:mm a");
            const declined = order.auditStatus === order_1.AuditStatus.Declined;
            const done = order.status === order_1.OrderStatus.Done || declined || completed;
            const paid = order.status === order_1.OrderStatus.Ready;
            const pendingClaims = order.status === order_1.OrderStatus.Pending ||
                order.status === order_1.OrderStatus.Progress;
            const pendingDispense = order.auditStatus === order_1.AuditStatus.Pending;
            /**
             * Done: Grey
             * Approvals: White
             * No Approvals: Red
             * Pending Claims: Yellow
             * Pending Dispense: Green
             */
            const rowColor = done
                ? "__grey"
                : paid
                    ? pendingDispense
                        ? "__green"
                        : "" // White
                    : pendingClaims
                        ? "__yellow"
                        : "__red";
            if (!this.showComplete && order.auditStatus !== order_1.AuditStatus.Unsubmitted)
                return false;
            return [
                React.createElement(React.Fragment, { key: "" },
                    React.createElement(list_item_1.MaterialListItem, { key: index, className: `prescribe--order-row${rowColor}`, onClick: () => this.handleClickRow(index) },
                        React.createElement(list_item_text_1.MaterialListItemText, { primary: (_d = patient.firstName) !== null && _d !== void 0 ? _d : "" }),
                        React.createElement(list_item_text_1.MaterialListItemText, { primary: (_e = patient.lastName) !== null && _e !== void 0 ? _e : "" }),
                        React.createElement(list_item_text_1.MaterialListItemText, { primary: apptTime !== null && apptTime !== void 0 ? apptTime : "" }),
                        React.createElement(list_item_text_1.MaterialListItemText, { primary: paid
                                ? `${approvals} Approvals`
                                : pendingClaims
                                    ? "Pending Approvals"
                                    : "No Approvals" }),
                        done ? (React.createElement(button_1.MaterialButton, { disabled: true }, "Finished")) : pendingClaims ? (React.createElement(button_1.MaterialButton, { disabled: true }, "Pending")) : (React.createElement(button_1.MaterialButton, { secondary: true, onClick: e => this.handleClickDone(e, order.id) }, pendingDispense ? "Undo" : "Confirm"))),
                    React.createElement(material_ui_1.Collapse, { in: this.currentRowIndex === index, children: this.renderRowEdit(order) }))
            ];
        };
        this.renderRowEdit = (order) => {
            var _a;
            const key = Math.random();
            return (React.createElement("div", { key: key }, (_a = order.claims) === null || _a === void 0 ? void 0 : _a.map((claim, i) => {
                var _a;
                const inventory = claim.inventory;
                const drugName = inventory.strengthDescription.length
                    ? inventory.strengthDescription
                    : inventory.name.length
                        ? inventory.name
                        : "MISSING_NAME";
                return claim.status === claim_1.ClaimStatus.Paid ? (React.createElement("div", { className: `prescribe--row-drug ${claim.prescribed ? "prescribe--row-drug__green" : ""}`, key: i },
                    React.createElement("div", { className: "prescribe--row-drug-text" },
                        React.createElement("span", null,
                            React.createElement("b", null, "NDC:"),
                            " ", (_a = inventory.package) !== null && _a !== void 0 ? _a : ""),
                        React.createElement("span", { style: { marginLeft: "2em" } },
                            React.createElement("b", null, "Drug:"),
                            " ",
                            drugName)),
                    React.createElement("div", null,
                        React.createElement("span", { onClick: () => this.handleClickModal(inventory), style: {
                                color: "steelblue",
                                cursor: "pointer",
                                marginRight: "2em"
                            } },
                            React.createElement("b", null, "More Info")),
                        order.auditStatus === order_1.AuditStatus.Unsubmitted ? (React.createElement(button_1.MaterialButton, { onClick: () => this.handleClickPrescribe(claim.id), primary: true }, claim.prescribed ? "Cancel" : "Prescribe")) : (React.createElement(React.Fragment, null))))) : (false);
            })));
        };
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        return ((_a = this.user) === null || _a === void 0 ? void 0 : _a.admin) || this.provider ? (React.createElement("div", { className: "prescribe--wrapper" },
            React.createElement(React.Fragment, null,
                React.createElement(kpi_header_1.KpiHeader, { center: false },
                    React.createElement(prescribe_kpi_1.PrescribeKpi
                    /** Going to need to fix this stuff. */
                    , { 
                        /** Going to need to fix this stuff. */
                        prescribeKpi: {
                            complete: (_b = this.complete) !== null && _b !== void 0 ? _b : 0,
                            provider: (_c = this.provider) !== null && _c !== void 0 ? _c : null,
                            remaining: (_d = this.incomplete) !== null && _d !== void 0 ? _d : 0,
                            siteName: (_f = (_e = this.site) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : ""
                        } })),
                React.createElement(floating_page_1.FloatingPage, null,
                    React.createElement("div", { className: "prescribe" },
                        React.createElement("div", { className: "prescribe--header" },
                            this.renderFilter(),
                            React.createElement(switch_1.MaterialSwitch, { label: "Show Completed Appointments", value: "false", onChange: this.handleClickShowComplete })),
                        React.createElement("div", { className: "prescribe--result" }, this.renderList())),
                    this.showModal && this.renderInfoModal())))) : !this.user ? (React.createElement(ui_1.UiLoadingIndicator, { className: "prescribe--loader" })) : (store_2.usersStore.showLock());
    }
    async componentDidMount() {
        this.user = store_2.usersStore.user.value;
        this.site = this.user.site;
        await this.loadOrders();
        this.handleSort("localeDate");
        const tick = setInterval(async () => {
            await this.loadOrders();
        }, 60 * 1000);
    }
    componentDidunmount() {
        // Need to kill the didMount tick here.
    }
};
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "complete", void 0);
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "incomplete", void 0);
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "ordersAll", void 0);
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "ordersFiltered", void 0);
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "showComplete", void 0);
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "showModal", void 0);
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "sortBy", void 0);
__decorate([
    mobx_1.observable
], PrescribeView.prototype, "sortDirection", void 0);
PrescribeView = __decorate([
    mobx_react_1.observer
], PrescribeView);
exports.PrescribeView = PrescribeView;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/prescribe/modules/prescribe-view/prescribe-view.tsx
// module id = 3832
// module chunks = 0